/**
 * The signature receipt tear-line: a subtle perforated edge rendered in pure CSS
 * (no image). Purely decorative — aria-hidden — and respects
 * prefers-reduced-motion (it has no motion, but the shimmer is gated regardless).
 *
 * Applied in exactly three places (Pack B): the top edge of document/template
 * preview frames, the top of the new-deposit form card, and the divider above
 * totals sections. Nowhere else.
 */
export function TearLine({ className = '' }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={`h-2 w-full ${className}`}
      style={{
        // A row of perforations: transparent punch-outs over the talon accent,
        // masked to a thin strip so it reads as a torn receipt edge.
        backgroundImage:
          'radial-gradient(circle at 4px 50%, transparent 0 2px, var(--rr-talon) 2px 3px, transparent 3px)',
        backgroundSize: '10px 100%',
        backgroundRepeat: 'repeat-x',
        opacity: 0.5
      }}
    />
  );
}
